import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-cart',
  templateUrl: './icon-cart.component.html',
  styleUrls: ['./icon-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCartComponent {}
